import React from 'react';
import { Play, PlayCircle, MessageCircle } from 'lucide-react';

interface VideoTutorialsProps {
  onNavigateToSupport?: () => void;
}

export default function VideoTutorials({ onNavigateToSupport }: VideoTutorialsProps) {
  return (
    <div className="max-w-4xl mx-auto space-y-8">
      {/* Introduction */}
      <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-sm">
        <div className="flex items-center space-x-4 mb-6">
          <div className="w-12 h-12 rounded-lg bg-indigo-100 dark:bg-indigo-900/50 flex items-center justify-center">
            <PlayCircle className="h-6 w-6 text-indigo-600 dark:text-indigo-400" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
              Vídeos Tutoriais
            </h1>
            <p className="text-gray-600 dark:text-gray-400">
              Aprenda a usar a plataforma com nossos vídeos explicativos.
            </p>
          </div>
        </div>
      </div>

      {/* Video Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Add your video tutorial cards here */}
        <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-sm">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            Em breve
          </h2>
          <p className="text-gray-600 dark:text-gray-400">
            Estamos preparando vídeos tutoriais incríveis para você. Fique ligado!
          </p>
        </div>
      </div>

      {/* Support CTA */}
      {onNavigateToSupport && (
        <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-sm text-center">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            Precisa de ajuda?
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mb-6">
            Nossa equipe de suporte está pronta para ajudar você.
          </p>
          <button
            onClick={onNavigateToSupport}
            className="inline-flex items-center px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
          >
            <MessageCircle className="h-5 w-5 mr-2" />
            Contato de Suporte
          </button>
        </div>
      )}
    </div>
  );
}